import PropTypes from 'prop-types';
import React from 'react';

const generateKey = () => 0 + new Date();

export default class FileInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            key: generateKey(),
        };
        this.onChange = this.onChange.bind(this);
    }

    render() {
        return (
            <input
                className={this.props.className}
                multiple={this.props.multiple}
                key={this.state.key}
                type="file"
                onChange={this.onChange}
            />
        );
    }

    onChange(onChangeEvent) {
        this.props.onChange(onChangeEvent);
        this.setState({
            key: generateKey(),
        });
    }
}
FileInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    multiple: PropTypes.bool,
};
FileInput.defaultProps = {
    className: 'file-input',
    multiple: true,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/uploader/file-input.jsx